import { Box } from "@mui/system";
import React from "react";
import styles from "../../../styles/components/video.module.scss";
import { disableStatuses } from "./HandleVideo";

const ButtonDisableWrapper = ({ index, status }) => {
  return (
    <div>
      {(index == status || disableStatuses.includes(status)) && (
        <Box className={styles.disable}></Box>
      )}
    </div>
  );
};

export default ButtonDisableWrapper;
